/* Sticky add-to-cart bar: mirrors the main product form */
(function () {
  'use strict';
  var bar = document.querySelector('[data-sticky-buy]');
  if (!bar) return;
  var form = document.querySelector('form[data-calc]');
  if (!form) return;
  var mainBtn = form.querySelector('[type="submit"]');
  var mainQty = form.querySelector('input[name="quantity"]');
  var qty = bar.querySelector('[data-sb-qty]');
  var unitEl = bar.querySelector('[data-sb-unit]');
  var money = function (c) { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(c / 100); };
  var val = function () { return Math.max(1, parseInt(qty.value, 10) || 1); };

  function render() {
    var n = val();
    var price = parseInt(bar.dataset.price, 10) || 0;
    var total = bar.querySelector('[data-sb-total]');
    if (total) total.textContent = money(n * price);
    if (unitEl) unitEl.innerHTML = n > 1 ? '<b>' + n + ' items</b>' : '';
  }
  function fromMain() { if (mainQty) { qty.value = Math.max(1, parseInt(mainQty.value, 10) || 1); render(); } }
  function toMain() {
    if (!mainQty) return;
    mainQty.value = val();
    mainQty.dispatchEvent(new Event('input', { bubbles: true }));
  }

  qty.addEventListener('input', function () { toMain(); render(); });
  qty.addEventListener('blur', function () { qty.value = val(); render(); });
  bar.querySelector('[data-sb-minus]').addEventListener('click', function () { qty.value = Math.max(1, val() - 1); toMain(); render(); });
  bar.querySelector('[data-sb-plus]').addEventListener('click', function () { qty.value = val() + 1; toMain(); render(); });
  form.addEventListener('input', function () { setTimeout(fromMain, 0); });
  form.addEventListener('click', function () { setTimeout(fromMain, 0); });
  document.addEventListener('aw:variant', function () { setTimeout(render, 0); });

  var add = bar.querySelector('[data-sb-add]');
  add.addEventListener('click', function () {
    toMain();
    if (form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click();
  });

  function show(on) {
    bar.classList.toggle('is-visible', on);
    if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    document.body.style.paddingBottom = on ? bar.offsetHeight + 'px' : '';
    document.documentElement.style.setProperty('--sb-h', on ? bar.offsetHeight + 'px' : '0px');
    if (on) fromMain();
  }
  if ('ResizeObserver' in window) {
    new ResizeObserver(function () {
      if (!bar.classList.contains('is-visible')) return;
      document.body.style.paddingBottom = bar.offsetHeight + 'px';
      document.documentElement.style.setProperty('--sb-h', bar.offsetHeight + 'px');
    }).observe(bar);
  }
  if ('IntersectionObserver' in window && mainBtn) {
    new IntersectionObserver(function (entries) { show(!entries[0].isIntersecting); }, { threshold: 0 }).observe(mainBtn);
  } else { show(true); }
  render();
})();
